import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: false,
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
      refetchIntervalInBackground: false,
    },
  },
});
